import React from "react";
import { Route } from "react-router";
import { LeadAssignmentsPage } from "features/LeadGen/pages/LeadAssignments";
import LeadDetailsFormProvider from "features/LeadGen/pages/LeadDetails/FormProvider/LeadDetailsFormProvider.tsx";
import LeadDetails from "features/LeadGen/pages/LeadDetails/LeadDetails.tsx";
import { ProtectedRoute } from "routes/ProtectedRoute";
import { UserNavigationGroup, UserRole } from "../../types/declarations/enums.ts";

export const LeadGenRoutes = ProtectedRoute({
	featureFlag: "leadGenEnabled",
	path: "lead-assignments",
	blackListNavGroupWithRoles: {
		[UserNavigationGroup.QUOTER]: [UserRole.USER]
	},
	children: (
		<>
			<Route
				index
				element={<LeadAssignmentsPage />}
			/>
			<Route
				path="lead/:leadAssignmentId"
				element={
					<LeadDetailsFormProvider>
						<LeadDetails />
					</LeadDetailsFormProvider>
				}
			/>
		</>
	)
});
